import React, { useEffect, useState } from "react";
import { Skeleton } from "../../../../components/ui/skeleton";
import { Button } from "../../../../components/ui/button";
import { useStepper } from "../../../../components/ui/stepper";
import { API, get, post } from "../../../../config";
import GoogleAuth from "../../../../assets/images/authenticator.png";
import MicroAuth from "../../../../assets/images/microsoft-authenticator.png";
import { useNavigate } from "react-router-dom";

const Step1 = ({ loading, setLoading }) => {
  const url = localStorage.getItem("ts-auth-email");
  const [twoFactorRegisterResponse, setTwoFactorRegisterResponse] = useState();

  const tfa = localStorage.getItem("ts-auth-tfa");
  const navigate = useNavigate();

  const { nextStep } = useStepper();
  
  useEffect(() => {
    setLoading(true);
    post(API.GOOGLE_2FA_REGISTER)
      .then((response) => {
        setLoading(false);
        setTwoFactorRegisterResponse(response.data);
      })
      .catch(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    get(API.LOGOUT)
      .then((response) => {
        if (response.status === 200) {
          localStorage.clear();
          window.location.href = "/";
        }
      })
      .catch(() => {
        var error = {};
        error["bt_error"] =
          "There is some issue with request, please try after some time.";
        this.setState({ errors: error });
      });
  };
  return (
    <div>
      <p className="pb-3 flex items-center">
        <span className="font-bold text-webPrimary mr-2">Step 1:</span> Open
        your{" "}
        <span className="flex gap-1 items-center pr-1">
          <img alt="authenticator" src={GoogleAuth} width={30} height={30} />
          <span className="pr-1">|</span>
          <img alt="authenticator" src={MicroAuth} width={30} height={30} />
        </span>
        Authenticator app.
      </p>
      <p className="pb-3">
        <span className="font-bold text-webPrimary mr-2">Step 2:</span> Add your
        account to the app by scanning this QR code.
      </p>
      <div className="flex flex-col items-center justify-center pb-3">
        <span className="h-[200px] w-[200px] dark:bg-white bg-muted rounded-xl">
          {loading ? (
            <Skeleton className="h-[200px] w-[200px] rounded-xl" />
          ) : (
            <img
              src={twoFactorRegisterResponse?.QR_Image}
              height={200}
              width={200}
              alt="QR"
            />
          )}
        </span>
        <span className="font-bold text-primary">OR</span>
        <p className="font-bold text-webPrimary mr-2">
          Enter a setup key: <span>{twoFactorRegisterResponse?.secret}</span>
        </p>
      </div>
      <p className="pb-3">
        <span className="font-bold text-webPrimary mr-2">Step 3:</span> Enter
        the 6-digit code found in your authenticator app under {url}.
      </p>
      <div className="flex gap-2 w-full items-center justify-end">
        <Button type="submit" onClick={() => nextStep()}>
          Next
        </Button>
        <Button variant="outline" size="default" onClick={() => Number(tfa) === 0 ? logout() : navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default Step1;
